import React, { useEffect,useState } from "react";
//import { submitTemplate } from "../../../../utils/spinningWheelApi";
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import { getTemplateDetail, getDefaultList } from "../../../../utils/spinningWheelApi";

const CommonTemplate = ({ selectedTemplate, selectedLayout, isTemplateId, widgetId, spinningWheelTabData,refreshWidgetList }) => {
    const [spinning, setSpinning] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [result, setResult] = useState(null);
    const [idleRotation, setIdleRotation] = useState(0);
    const [hasSpun, setHasSpun] = useState(false); 
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [copied, setCopied] = useState(false);

    // Default values for the spinningWheelTabData
    const {
        is_website_frontend,
        button_position,
        button_text,
        is_show_email,
        background_color,
        text_color, 
        accent_color,
        email_field_error_color,
        heading,
        description,
        footer_text,
    } = spinningWheelTabData || {};

    //useEffect Open or close popup handler
    useEffect(() => {
        if (is_website_frontend === "website-frontend") {
            // Website frontend: show popup only if not closed before
            if (!sessionStorage.getItem("wheel_closed_once")) {
                setShowPopup(true);
            } else {
                setShowPopup(false);
            }
        } else {
            // Dashboard or anywhere else: always show popup
            setShowPopup(true);
        }
    }, [is_website_frontend]);

    //Close popup if botton pustion changed
    useEffect(() => {
        setShowPopup(false);
    }, [button_position]);

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/spinning-wheel/temp-css/SpinningWheel.css`;
        if (widgetId) {
            link.setAttribute("spinning-wheel-data-dynamic-css", "spinning-wheel");
        } else {
            link.setAttribute("data-dynamic-css", "spinning-wheel");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="spinning-wheel"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    //handler spinWheel
    const spinWheel = () => {
        if (spinning || hasSpun) return;

        //check if email is enable or not
        if (Number(is_show_email) === 1) {
            // Basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!email || !emailRegex.test(email)) {
                setEmailError(true);
                return;
            }
        }

        const spins = 5;
        const prizeIndex = Math.floor(Math.random() * prizes.length);
        const anglePerSlice = 360 / prizes.length;
        // This is the angle to align the selected prize with the pointer (right side / 0 degrees)
        const targetAngle = 360 - (prizeIndex * anglePerSlice + anglePerSlice / 1.20);
        // Add extra spins to make it look realistic
        const finalRotation = spins * 360 + targetAngle;

        setSpinning(true);
        setRotation(finalRotation);
        setHasSpun(true);

        setTimeout(() => {
            setSpinning(false);
            setResult(prizes[prizeIndex]);
        }, 4000);
    };

    //Handle for auto speed sppining
    useEffect(() => {
        if (hasSpun) return; 

        const interval = setInterval(() => {
            setIdleRotation(prev => prev + 0.3); 
        }, 16); 

        return () => clearInterval(interval);
    }, [hasSpun]);

    //UseEffect for habdle apis
    useEffect(() => {
        const fetchData = async () => {
            try {
                let api_result;
                if (isTemplateId) {
                    api_result = await getTemplateDetail(isTemplateId);
                } else if (widgetId) {
                    api_result = await getSingleWidgetDetail(widgetId);
                } else {
                    api_result = await getDefaultList();
                }
                setApiData(api_result);
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    //Prizes List
    //const prizes = ['BOGO', '50% Off', 'Free Shipping', '50% Off', 'Early Access', 'BOGO', '50% Off', 'Free Shipping', '50% Off', 'Early Access'];
    const repeatCount = 2;
    const basePrizes = apiData?.data?.data_list || [];
    const prizes = Array(repeatCount).fill(basePrizes).flat();
    const baseColor1 = accent_color; 
    const baseColor2 = lightenColor(accent_color, 20);  // 20% lighter

    //Generate Gradient Color
    function generateGradient(prices, color1, color2) {
        const sliceCount = prices.length;
        const sliceAngle = 360 / sliceCount;

        let gradientParts = [];

        for (let i = 0; i < sliceCount; i++) {
            const startDeg = i * sliceAngle;
            const endDeg = (i + 1) * sliceAngle;
            const color = i % 2 === 0 ? color1 : color2;
            gradientParts.push(`${color} ${startDeg}deg ${endDeg}deg`);
        }

        return `conic-gradient(${gradientParts.join(", ")})`;
    }
    const gradientString = generateGradient(prizes, baseColor1, baseColor2);

    //Handler to light color
    function lightenColor(hex, percent) {
        // Remove '#' if present
        hex = hex.replace(/^#/, '');

        // Parse r, g, b values
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        // Increase each channel by percent (0-100)
        r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
        g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
        b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));

        // Convert back to hex and return
        return `#${((1 << 24) + (r << 16) + (g << 8) + b)
            .toString(16)
            .slice(1)
            .toUpperCase()}`;
    }

    //Function for hanlde color
    function getReadableTextColor(bgColor) {
        if (!bgColor) return '#ffffff';
        const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);

        // Formula for luminance
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
        return luminance > 186 ? '#000000' : '#ffffff';
    }
    const textColor = getReadableTextColor(accent_color);

    return (
        <>
            <div className={`upgadeify-spinning-wheel-template-main ${is_website_frontend} ${showPopup ? 'spinning-wheel-popup' : ''}`}>
                <div className={`upgadeify-spinning-wheel-float_btn ${button_position}`}>
                    <button className="upgadeify-spinning-wheel-float_btn_button" style={{ background: accent_color, color: textColor}} onClick={() => setShowPopup(true)}>
                        {button_text}
                    </button>
                </div>

                {showPopup && (
                <div className="upgadeify-spinning-wheel-template" style={{ background: background_color}}>
                    <button className="upgadeify-spinning-wheel-close" onClick={() => {
                        if (is_website_frontend === "website-frontend") {
                            sessionStorage.setItem("wheel_closed_once", "true");
                        }
                        setShowPopup(false);}}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" d="m3.426 2.024.094.083L8 6.586l4.48-4.479a1 1 0 0 1 1.497 1.32l-.083.095L9.414 8l4.48 4.478a1 1 0 0 1-1.32 1.498l-.094-.083L8 9.413l-4.48 4.48a1 1 0 0 1-1.497-1.32l.083-.095L6.585 8 2.106 3.522a1 1 0 0 1 1.32-1.498Z"></path></svg>
                    </button>
                    <div className="upgadeify-spinning-wheel-template-row">
                        <div className="wheel-container">
                            <div className="wheel" style={{ background: gradientString, border: '6px solid '+lightenColor(accent_color, 40), transform: `rotate(${hasSpun ? rotation : idleRotation}deg)`}}>
                                {prizes.map((prize, index) => {
                                    const sliceAngle = 360 / prizes.length;
                                    const rotateAngle = index * sliceAngle;

                                    return (
                                        <div key={index} className="wheel-slice" style={{ transform: `rotate(${rotateAngle}deg)`,}}>
                                            <span className="wheel-label" style={{ color: textColor, transform: `rotate(${sliceAngle / 1}deg)`,}}>{prize.price_name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                            
                            <div className="upgadeify-spinning-wheel-center-circle"></div>
                            <div className="upgadeify-pointer right-pointer">
                                <svg width="46" height="30" viewBox="0 0 46 30" fill={accent_color} xmlns="http://www.w3.org/2000/svg"><path d="M46 24.902C46 28.5435 41.3783 31.0083 37.1981 29.5961L2.32965 17.8165C-0.77655 16.7671 -0.77655 13.2329 2.32965 12.1835L37.1981 0.403906C41.3783 -1.00831 46 1.45645 46 5.09802V24.902Z" fill={accent_color}></path><path d="M46 24.902C46 28.5435 41.3783 31.0083 37.1981 29.5961L2.32965 17.8165C-0.77655 16.7671 -0.77655 13.2329 2.32965 12.1835L37.1981 0.403906C41.3783 -1.00831 46 1.45645 46 5.09802V24.902Z" class="pointer__BottomLayer-sc-68bd8096-2 lcRTT"></path><path d="M43.5 22.9216C43.5 24.1239 42.6695 25.2024 41.316 25.8665C39.9697 26.527 38.188 26.7257 36.4945 26.1994L6.17418 16.7757C4.974 16.4027 4.5 15.6418 4.5 15C4.5 14.3582 4.974 13.5973 6.17418 13.2243L36.4945 3.8006C38.188 3.27426 39.9697 3.47297 41.316 4.13352C42.6695 4.79762 43.5 5.87613 43.5 7.07841V22.9216Z" class="pointer__TopLayer-sc-68bd8096-1 khkgFG"></path><defs><linearGradient id="paint0_linear_3646_12263" x1="26.3289" y1="22.9371" x2="18.9843" y2="-7.0233" gradientUnits="userSpaceOnUse"><stop stop-color="#FAFAFA"></stop><stop offset="1" stop-color="#E7E7E7"></stop></linearGradient></defs></svg>
                            </div>
                        </div>
                        <div className="upgadeify-spinning-wheel_details_right">
                        {!result ? (
                            <>
                            <div className="upgadeify-spinning-wheel_title" style={{ color: text_color}}>
                                {heading}
                            </div>
                            <div className="upgadeify-spinning-wheel_details" style={{ color: text_color}}>
                                {description}
                            </div>
                            <div className="upgadeify-spinning-wheel_prizes">
                                {Number(is_show_email) === 1 && ( 
                                    <>
                                    <input type="text" placeholder="Enter your email..." value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            setEmailError(false); 
                                        }}
                                        className="upgadeify-spinning-wheel_prize-checkbox"
                                        style={{
                                            border: `2px solid ${emailError ? email_field_error_color : 'rgba(17, 17, 17, 0.3)'}`
                                        }}
                                    />
                                   {emailError && (
                                        <div className="upgadeify-spinning-wheel_prize-error" style={{ color: email_field_error_color }}>
                                            Please enter a valid email address.
                                        </div>
                                    )}
                                    </>
                                )}
                                <button className="upgadeify-spinning-wheel_prize-button" onClick={spinWheel} disabled={spinning} style={{ background: accent_color, color: textColor}}>{spinning ? "Spinning..." : "Spin Now"} </button>
                            </div>
                            <div className="upgadeify-spinning-wheel_no_thanks" style={{ color: text_color}} onClick={() => {
                                    if (is_website_frontend === "website-frontend") {
                                        sessionStorage.setItem("wheel_closed_once", "true");
                                    }
                                    setShowPopup(false);
                                    setEmailError(false);
                                    setResult(null);
                                    setHasSpun(null);
                                }}>
                                No, Thank you
                            </div>
                            {footer_text && (
                                <div className="upgadeify-spinning-wheel_footer_text" style={{ color: text_color}}>
                                    {footer_text}
                                </div>
                            )}
                        </>
                            ) : (
                                <>
                                <div className="upgadeify-spinning-wheel_result-wrapper" style={{ color: text_color }}>
                                    <div className="upgadeify-spinning-wheel_title" style={{ color: text_color}}>
                                        {result?.content_heading}
                                    </div>
                                    <div className="upgadeify-spinning-wheel_details" style={{ color: text_color}}>
                                        {result?.content_text}
                                    </div>
                                    <div className="upgadeify-spinning-wheel_promocode" style={{ color: text_color}}>
                                        <div className="upgadeify-spinning-clickto_copy" onClick={() => {
                                                if (result?.content_promocode) {
                                                    navigator.clipboard.writeText(result.content_promocode)
                                                        .then(() => {
                                                            setCopied(true);
                                                            setTimeout(() => setCopied(false), 2000);
                                                        });
                                                }
                                            }}
                                            style={{ cursor: 'pointer' }}>
                                            {copied ? "Copied!" : "Click To Copy"}
                                        </div>
                                        {result?.content_promocode}
                                    </div>
                                    <button className="upgadeify-spinning-wheel_prize-button" style={{ background: accent_color, color: textColor}} onClick={() => {
                                        if (result?.content_action_link) {
                                            window.open(result?.content_action_link, '_blank');
                                        }
                                    }} >{result?.content_action_button}</button>
                                </div>
                                <div className="upgadeify-spinning-wheel_no_thanks" style={{ color: text_color}} onClick={() => {
                                    if(is_website_frontend === "website-frontend") {
                                        sessionStorage.setItem("wheel_closed_once", "true");
                                    } 
                                    setShowPopup(false);
                                    setEmailError(false);
                                    setResult(null);
                                    setHasSpun(null);
                                }}>
                                    No, Thank you
                                </div>
                                {footer_text && (
                                    <div className="upgadeify-spinning-wheel_footer_text" style={{ color: text_color}}>
                                        {result?.content_footer_text}
                                    </div>
                                )}
                            </>
                            )}
                            
                        </div> 
                    </div>
               </div>
               )}
            </div>
        </>
    );
};

export default CommonTemplate;
